import Api from '../Api';
import ApexCharts from 'apexcharts'

export default class LastSharesCard {
    constructor(chartDiv, coin = 'bch', wallet = '') {
        this.rawData = [];
        this.coin = coin;
        this.wallet = wallet;
        this.chart = new ApexCharts(chartDiv, this.getChartOptions());
        this.chart.render(); 
    }

    async render() {
        try {
            if (this.wallet) {
                this.rawData = await Api.miner.submitsChart(this.coin, this.wallet);
            } else {
                this.rawData = await Api.mine.submitsChart(this.coin);
            }

            this.bestShare = this.rawData.reduce((acc, val) => acc[3] > val[3] ? acc : val);

            this.chart.updateOptions(this.getChartOptions());
            this.chart.updateSeries(this.getSeries());
        } catch (error) {
            
        }
    }

    getChartOptions() {
        return {
            chart: {
                zoom: { enabled: false },
                height: 240,
                type: 'bar',
                parentHeightOffset: 0,
                toolbar: {
                    show: false
                },
                animations: {
                    enabled: false
                }
            },
            dataLabels: {
                enabled: false
            },
            fill: {
                // opacity: 0.16,
                type: 'solid'
            },
            xaxis: {
                labels: {
                    datetimeUTC: false
                },
                tooltip: {
                    enabled: false
                },
                axisBorder: {
                    show: false
                },
                type: 'datetime'
            },
            yaxis: {
                logarithmic: true,
                logBase: this.coin == 'rvn' ? 2 : 10,
                labels: {
                    formatter: function(val, index) {
                        if (val > 1000 * 1000 * 1000) return Math.round(val / 1000000000 * 100) / 100 + 'G';
                        else if (val > 1000 * 1000) return Math.round(val / 1000000 * 100) / 100 + 'M';
                        else if (val > 1000) return Math.round(val / 1000 * 100) / 100 + 'K';
                        else return Math.round(val * 100) / 100;
                    }
                }
            },
            tooltip: {
                theme: 'dark',
                x: {
                    format: "HH:mm"
                }
            },
            grid: {
                padding: {
                    top: -20,
                    right: 0,
                    left: -4,
                    bottom: -4
                },
                strokeDashArray: 4
            },
            legend: { show: false },
            labels: this.rawData.map(d => d[0]),
            series: []
        }
    }

    getSeries() {
        return [{
            name: "Best share",
            data: this.rawData.map(d => d[3])
        }];
    }
}